<div
  class="vc_previewBox"
  [ngClass]="{'vc_previewBox--active': isActive}"
  [style.right]="isLgUp ? right_pos : 0"
  [style.width.px]="width && isLgUp ? width : null"
>
  <div class="vc_previewBox__arrow"></div>
  <div class="vc_previewBox__header">
    <div *ngIf="title" class="vc_previewBox__title">{{ title }}</div>
    <button class="vc_previewBox__closeBtn" (click)="closePreviewBox()"></button>
  </div>
  <div class="vc_previewBox__inner"><ng-content></ng-content></div>
</div>
